import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { typography, color, textEllipsis, transition } from '@dayancloud/common/theme'

const CardContainer = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  transition: ${transition(['background-color'])};
  :hover {
    background-color: #f2f2f6;
  }
  :hover .title {
    color: ${color.primary};
  }
  .title {
    color: #666;
    font-size: ${typography.textSmall};
    margin-bottom: 8px;
    ${textEllipsis};
  }
  .time {
    font-size: ${typography.textThin};
    font-weight: 400;
    color: #999999;
  }
`

class LastestCard extends React.PureComponent {
  render() {
    const { title, slug, time } = this.props
    return (
      <Link to={`/${slug}/`} target='_blank'>
        <CardContainer>
          <div className='title'>{title}</div>
          <div className='time'>{time}</div>
        </CardContainer>
      </Link>
    )
  }
}

LastestCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
}

export default LastestCard
